<template>
  <div class="core">

    <table id="dataTable">

        <tr>
          <th>
            #
          </th>
          <th v-for="key in keys" v-bind:key="key">
            {{ key }}
          </th>
        </tr>

        <tr v-for="(item,index) in data" v-bind:key="item._id">
          <td>
            {{ (index+1)+indexFix }}
          </td>

          <td v-for="key in keys" v-bind:key="key">
              {{ (item[key])?item[key]:"-"}}
          </td>
        </tr>
    </table>

  </div>
</template>

<script>
import moment from "moment"

export default {
  name: "DataTable",

  props:{
    data:Array,
    keys:Array,
    indexFix:Number
  },

  mounted() {

  },

  created: function () {
    this.moment = moment;
  },
}
</script>

<style scoped>
.core{
  height: calc(100% - 5.7vw);
}

#dataTable {
  font-size: 0.8vw;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  border-color: #DDD;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}

#dataTable td, #dataTable th {
  border: 1px solid #ddd;
  padding-left: 2vw;
  padding-top: 1vw;
  padding-right: 2vw;
  padding-bottom: 1vw;
}

#dataTable th {
  text-align: left;
  color: #999;
}
</style>